import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "uxp-for-web-developers"
    }}>{`UXP for Web Developers`}</h1>
    <p>{`At first glance, developing for UXP in Adobe applications looks very familiar to people coming from web development. UXP uses the familiar structure of HTML, CSS, and JavaScript to build what look like web pages but are actually dialogs and panels.`}</p>
    <p>{`It's not sufficient to know those three technologies when writing UXP plugins; as a developer, you also have to be familiar with the host application's API. This is where the Web and UXP seriously diverge. There's nothing like an application API for websites, yet to accomplish anything useful in XD, Photoshop, or any other Creative Cloud application that supports UXP, you have to know the app.`}</p>
    <p>{`For Adobe Photoshop, the API documentation can be found `}<a parentName="p" {...{
        "href": "../../ps_basics/"
      }}>{`here`}</a>{`. For Adobe XD, the API documentation is `}<a parentName="p" {...{
        "href": "https://adobexdplatform.com"
      }}>{`here`}</a>{`.`}</p>
    <p>{`UXP plugins also have a different directory structure than typical websites. There is a required `}<a parentName="p" {...{
        "href": "../../uxp_guide/uxp-misc/manifest-v4/"
      }}>{`manifest file`}</a>{` at the top level of the directory. There is also a set of icons which contains png images that are used when a panel is minimized in Photoshop. While these icons are optional for development, they are `}<em parentName="p">{`mandatory`}</em>{` for distribution; your plugin will be fail submission if it lacks the proper icon structure.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      